<template>
  <header class="o-the-header">
    <MoleculeTheHeaderLimitDate v-if="!$store.getters.getAcademyData.is_licencia_paga && $store.getters.getAcademyData.licencia.venta !== ''"/>
    <MoleculeTheHeaderAcademyDataRequired v-if="$store.getters.getAcademyData.persona === undefined && $store.getters.getAcademyData.is_licencia_paga"/>
    <div class="o-the-header-navigation">
      <MoleculeTheHeaderLogo :is-loading="isLoading"/>
      <MoleculeTheHeaderNavigation :is-loading="isLoading"/>
      <MoleculeTheHeaderSubMenu/>
    </div>
  </header>
</template>

<script>
export default {
  name: 'OrganismTheHeader',

  components: {
    MoleculeTheHeaderLogo: () => import('@/components/molecules/MoleculeTheHeaderLogo'),
    MoleculeTheHeaderNavigation: () => import('@/components/molecules/MoleculeTheHeaderNavigation'),
    MoleculeTheHeaderSubMenu: () => import('@/components/molecules/MoleculeTheHeaderSubMenu'),
    MoleculeTheHeaderLimitDate: () => import('@/components/molecules/MoleculeTheHeaderLimitDate'),
    MoleculeTheHeaderAcademyDataRequired: () => import('@/components/molecules/MoleculeTheHeaderAcademyDataRequired')
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
